import { commonApi } from '@/services/api';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import { isEnablePhoneSecondStepCopy } from '@/utils/phoneSecondStepCopyExperiment';

export type PhoneRecommendationType = 'add_phone_step' | 'optimize_phone_copy';
export interface PhoneRecommendation {
  id: string;
  recommendationType: PhoneRecommendationType;
  abCreateDisabled?: boolean;
}

/** 推荐资格由后端统一判断，前端不根据提交统计量推断配置。 */
export async function getPhoneRecommendations(): Promise<PhoneRecommendation[]> {
  // 非灰度店铺不请求新增接口；实际资格和冷却仍由后端校验。
  if (!isEnablePhoneSecondStepCopy()) return [];
  const response = await commonApi({}, 'cartsee.form.phoneRecommend.qualification', false);
  // 空数据或异常返回形态按无推荐处理，避免列表 computed 调用 find 时崩溃。
  return Array.isArray(response.data.data) ? response.data.data : [];
}

export async function getPhoneRecommendPreview(
  id: string,
  settings?: PopSettingsVO,
  phoneRecommendSourceVersion?: number,
  recommendationType: PhoneRecommendationType = 'add_phone_step',
): Promise<TFormSaveDetailRequest<PopSettingsVO>> {
  const response = await commonApi(
    { id, settings, phoneRecommendSourceVersion, recommendationType },
    'cartsee.form.phoneRecommend.preview',
  );
  return response.data.data;
}

export async function dismissPhoneRecommend(
  id: string,
  recommendationType: PhoneRecommendationType,
): Promise<boolean> {
  const response = await commonApi(
    { id, recommendationType },
    'cartsee.form.phoneRecommend.dismiss',
    false,
  );
  return response.data.data === true;
}

export async function createPhoneRecommendAb(
  id: string,
  recommendationType: PhoneRecommendationType,
): Promise<void> {
  await commonApi({ id, recommendationType }, 'cartsee.form.phoneRecommend.createAb');
}
